// extracted by mini-css-extract-plugin
export default {"list":"EventParticipants-module-fcfe22be44a29c6b3fec"};